var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg19Kokusai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1270A3;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,0C6.3,0,0,6.3,0,14s6.3,14,14,14s14-6.3,14-14S21.7,0,14,0z M8,14c0-1.4,0.1-2.7,0.4-4H13v8H8.4 C8.1,16.7,8,15.4,8,14z M19.2,8H15V2.2C16.8,2.8,18.3,5,19.2,8z M13,2.2V8H8.8C9.7,5,11.2,2.8,13,2.2z M13,20v5.8 C11.2,25.2,9.7,23,8.8,20H13z M15,25.8V20h4.2C18.3,23,16.8,25.2,15,25.8z M15,18v-8h4.6c0.2,1.3,0.4,2.6,0.4,4s-0.1,2.7-0.4,4H15z  M21.7,10h3.6c0.4,1.3,0.7,2.6,0.7,4s-0.3,2.7-0.7,4h-3.6c0.2-1.3,0.3-2.6,0.3-4S21.9,11.3,21.7,10z M24.4,8h-3.1 c-0.5-1.9-1.2-3.5-2.1-4.8C21.3,4.2,23.2,5.9,24.4,8z M8.9,3.2C8,4.5,7.3,6.1,6.8,8H3.6C4.8,5.9,6.7,4.2,8.9,3.2z M2.7,10h3.6 C6.1,11.3,6,12.6,6,14s0.1,2.7,0.3,4H2.7C2.3,16.7,2,15.4,2,14S2.3,11.3,2.7,10z M3.6,20h3.1c0.5,1.9,1.2,3.5,2.1,4.8 C6.7,23.8,4.8,22.1,3.6,20z M19.1,24.8c0.9-1.3,1.6-3,2.1-4.8h3.1C23.2,22.1,21.3,23.8,19.1,24.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19Kokusai);
export default __webpack_public_path__ + "static/media/19_kokusai.7fd7cf31f8fe84d7ea0b33678ba807af.svg";
export { ForwardRef as ReactComponent };